<div [attr.data-has-open-submenu]="(openMenuItemUid$ | async) ? 'true' : 'false'">
  <nav [testId]="'nav-menu-' + uid" class="nav-menu" aria-label="Main Navigation">
    <ul class="nav-menu__list" *ngIf="menuItems$ | async as menuItems">
      <li
        class="nav-menu__item-wrapper"
        *ngFor="let child of menuItems; let i = index"
        (mouseenter)="handleItemMouseEnter(child.uid!, $event)"
        (mouseleave)="handleItemMouseLeave(child.uid!, $event)"
        (pointerenter)="handleItemMouseEnter(child.uid!, $event)"
        (pointerleave)="handleItemMouseLeave(child.uid!, $event)"
      >
        <div class="nav-menu__item nav-menu__item--grow">
          <ng-container *ngFor="let entry of child.entryComponents">
            <ng-container *ngIf="entry">
              <a
                *ngIf="isExternal(entry); else internalLink"
                class="nav-menu__item-title"
                [attr.href]="setUrl(entry)"
                [target]="getTarget(entry)"
              >
                {{ entry.linkName || child.title }}
              </a>
              <ng-template #internalLink>
                <a class="nav-menu__item-title" [routerLink]="entry.locUrl" [target]="getTarget(entry)">
                  {{ entry.linkName || child.title }}
                </a>
              </ng-template>
            </ng-container>
          </ng-container>
        </div>
        <div
          [testId]="'menu-item-' + i"
          class="nav-menu__item"
          *ngIf="child.children && child.children.length > 0; else placeholderMenuItem"
        >
          <app-gg-navigation-dropdown
            [isOpen]="isSubmenuOpen(child.uid!)"
            [controlsId]="'submenu-' + child.uid"
            [label]="'More ' + (child.title || 'items') + ' pages'"
            (triggerClick)="toggleSubmenu(child.uid!, $event)"
          >
          </app-gg-navigation-dropdown>
          <div class="nav-menu__viewport" [attr.data-state]="isSubmenuOpen(child.uid!) ? 'open' : 'closed'">
            <button
              type="button"
              [attr.aria-label]="'common.close' | cxTranslate"
              [attr.aria-expanded]="isSubmenuOpen(child.uid!)"
              (click)="toggleSubmenu(child.uid!, null!)"
              class="nav-menu__close-submenu-button"
            >
              <span class="visually-hidden">{{ 'common.close' | cxTranslate }}</span>
            </button>
            <div
              class="nav-menu__submenu"
              [id]="'submenu-' + child.uid"
              [style.display]="isSubmenuOpen(child.uid!) ? 'block' : 'none'"
              role="region"
              [attr.aria-labelledby]="'submenu-title-' + child.uid"
              (focusout)="onSubmenuFocusOut($event, child.uid!)"
            >
              <h4 class="nav-menu__submenu-title" [id]="'submenu-title-' + child.uid">{{ child.title }}</h4>
              <ul class="nav-menu__submenu-list">
                <li
                  class="nav-menu__submenu-list-item"
                  *ngFor="let submenuItem of child.children; let subIndex = index"
                >
                  <ng-container *ngIf="submenuItem.entries?.[0] as entry">
                    <ng-template
                      [cxComponentWrapper]="{
                        flexType: entry.itemType,
                        typeCode: entry.itemType,
                        uid: entry.itemId,
                      }"
                      (keydown)="onSubmenuItemKeydown($event, child.uid!, subIndex, child.children.length)"
                    ></ng-template>
                  </ng-container>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </nav>
</div>

<ng-template #placeholderMenuItem>
  <div class="nav-menu__item nav-menu__item--placeholder"></div>
</ng-template>
